import { Injectable } from '@angular/core';

Injectable();

@Injectable()
export class QueryStringParamService {
  constructor() {}

  // This method is used because .NET wants array QS params to be ?key=value1&key=value2...
  public deserializeObjectToParams(param: object): string {
    let qS = '';

    // only look at non-prototypical properties
    Object.getOwnPropertyNames(param).forEach(p => {
      // in JS arrays are just objects where the index is the key,
      // so we have to see if we're looking at an iterable object and handle it differently
      if (typeof param[p] === 'object') {
        try {
          if (Object.values(param[p]).length > 0) {
            const arrValues = Object.values(param[p]);

            for (const value of arrValues) {
              if (qS.indexOf('?') >= 0) {
                qS += `&${p}=${value}`;
              } else {
                qS += `?${p}=${value}`;
              }
            }
          }
        } catch (err) {
          throw err;
        }
      } else {
        // param[p] is a primitive so just add its value directly
        if (qS.indexOf('?') >= 0) {
          qS += `&${p}=${param[p]}`;
        } else {
          qS += `?${p}=${param[p]}`;
        }
      }
    });

    return qS;
  }
}
